import { createWebHistory, createRouter } from "vue-router";
import routes from './routes'
import store from '../state/store'
import { menuItems } from "../components/menu";

const router = createRouter({
  history: createWebHistory(),
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

let LOGIN_URL = '/login';  
try {
  const cfgStr = localStorage.getItem('config');
  if (cfgStr) {
    const cfg = JSON.parse(cfgStr);
    if (cfg.LOGIN_URL) {
      LOGIN_URL = cfg.LOGIN_URL;
    }
  }
} catch (e) {
  console.warn("Config henüz yüklenmemiş olabilir:", e);
}


router.beforeEach((to, from, next) => {

  let link = to.name; 
  if (link != "default" && link != "sendverificationemail" && link != "forgotpassword" && link != "sessiondefault") {
    if (link != "login") {
      if (store.getters["auth/isAuth"]) {
        let roller = store.getters["auth/UserRolles"]
        // let YetkiSorgu = []
        //  let SayfaRolleri = []  

        /*
              for(let i=0; i<menuItems.length; i++){
                var submenu = menuItems[i].subItems
                if(submenu.length != 0){
                  for(let j=0; j<submenu.length;j++){
                    YetkiSorgu= submenu.filter(notification => notification.link.includes(link)); 
                 
                    if(YetkiSorgu.length !=0){
                      SayfaRolleri = YetkiSorgu[0].role
                    }
                  } 
                }else{
                  YetkiSorgu= menuItems.filter(notification => notification.link.includes(link)); 
                  if(YetkiSorgu.length !=0){ 
                    SayfaRolleri = YetkiSorgu[0].role
                  } 
                }
  
              }       
          */
        const findMenuItem = (items, linkToFind) => {
          for (let item of items) {
            if (item.link && item.link.includes(linkToFind)) {
              return item;
            }
            if (item.subItems) {
              const foundSubItem = findMenuItem(item.subItems, linkToFind);
              if (foundSubItem) {
                return foundSubItem;
              }
            }
          }
          return undefined;
        };

        const MenuItem = findMenuItem(menuItems, "/" + link);

        const SayfaRolleri = MenuItem ? MenuItem.role : undefined;


        let kontrol = false
        for (let a = 0; a < SayfaRolleri.length; a++) {
          if (SayfaRolleri[a] != "*") {
            let YetkiSorgu = roller.filter(function (Role) {
              return Role == SayfaRolleri[a];
            });
            if (YetkiSorgu.length != 0) kontrol = true
          } else {
            kontrol = true
          }
        }
        if (kontrol) next()
        else router.push("/");

      } else {

        window.location.href = LOGIN_URL
      }
    } else {
      next()
    }
  } else { 
    next()
  } 
});


export default router
